import React from "react";
import logo from '../assets/images/logo.png'
import '../assets/css/logo.css'

export const Logo = () => {
  return (
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>
  );
};

